<template>
  <div class="container-fluid">
    <h1 class="detail-title">
      <i id="sidebar" class="fa fa-bars sidebar" @click="toggleSidebar"></i>
      Organization Details</h1>
    <div id="card">
      <div id="organization">
        <div class="card-section" id="scroll">
          <popups></popups>
          <div class="row section-body">
              <div class="col-sm-3 section-property-block">
                <p class="section-property-title">Name</p>
                <input id="organization-name" type="text" name="name" placeholder="--"
                  v-on:blur="fieldWatcher($event)" :value="selectedOrganization.name"
                  :disabled="! canEdit" />
              </div>

              <div class="col-sm-3 section-property-block">
                <p class="section-property-title">Created</p>
                <dropdown class="form-group">
                  <div class="input-group">
                    <input id="organization-created" disabled="disabled" type="datetime"
                        name="created" placeholder="--"
                        :value="formatDateTime(selectedOrganization.created, 'MMMM DD YYYY, hh:mm A')"
                        :disabled="! canEdit" />
                    <div class="input-group-btn">
                      <btn class="dropdown-toggle" disabled><i class="glyphicon glyphicon-calendar"></i></btn>
                    </div>
                  </div>
                  <template slot="dropdown">
                    <li><date-picker/></li>
                  </template>
                </dropdown>
              </div>

              <div class="col-sm-3 section-property-block">
                <p class="section-property-title">State</p>
                <select id="organization-status" name="status" class="section-property">
                    <option v-for="option in status_options"
                        :selected="selectedOrganization.state == option? 'selected' : ''"
                        :value="option" :disabled="! canEdit"
                        >{{ option | capitalize }}

                    </option>
                </select>
              </div>
          </div>
          <div class="row section-body">
            <div class="col-sm-6 section-property-block">
              <p class="section-property-title">Address</p>
              <textarea
                id="organization-address" placeholder="--"
                v-on:blur="fieldWatcher($event)"
                name="address" :disabled="! canEdit"
                >{{ selectedOrganization.address }}</textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="card-section">
        <div class="row">
          <div class="col-sm-3">
            <h1 class="section-title">Contacts</h1>
          </div>
        </div>
        <div v-if="selectedOrganizationContacts.length > 0">
          <div v-for="(contact, index) in selectedOrganizationContacts">
            <div class="row section-body contact" v-for="fields in contact_fields">
              <div class="col-sm-3 section-property-block" v-for="field in fields">
                <p class="section-property-title">{{ field | capitalize }}</p>
                <select v-if="field === 'contact_method'" :id="'contact_method-'+ index"
                      :ref="'category-'+ index"
                      :name="field+'-'+index" class="section-property" :disabled="! canEdit" >
                  <option value="">Select A Category</option>
                  <option v-for="option in contact_options"
                      :selected="contact.category == option? 'selected' : ''"
                      :value="option">{{ option | capitalize }}
                  </option>
                </select>
                <input v-else :id="'value-'+ index" :ref="'value-'+ index"
                    type="text" :name="field+ '-'+index" :value="contact.value"
                    :disabled="! canEdit" placeholder="Enter value"/>

              </div>
              <div class="col-sm-4">
                <div class="col-sm-1">
                  <div class="minus" @click="removeContact(index)">
                    <img src="../../assets/letter-x.svg" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <p>No contacts available</p>
        </div>
      </div>

      <div class="card-section sub-section more" v-if="canEdit">
        <div class="row">
          <div class="col-sm-3">
            <h1 class="section-title">Add Contacts</h1>
          </div>
        </div>
        <div class="row section-body additional" v-for="(contact, index) in additional_contact_fields">
          <div class="col-sm-3 section-property-block" v-for="field in contact">
            <p class="section-property-title">{{ field | capitalize }}</p>
            <select v-if="field === 'contact_method'" :id="'add-contact_method-'+ index"
                  :ref="'contact_method-'+ index"
                  :name="field+'-'+index" class="section-property" >
              <option value="">Select A Contact Method</option>
              <option v-for="option in contact_options"
                  :value="option">{{ option | capitalize }}
              </option>
            </select>
            <input v-else :id="'value-'+ index" :ref="'value-'+ index"
                type="text" :name="field+ '-'+index"
                placeholder="Enter value" />
          </div>
          <div class="col-sm-4" v-if="index < 1 && canEdit" >
            <div class="col-sm-1" v-if="!hasExceeded">
              <div class="plus" @click="toggleContact('add')">
                <img src="../../assets/plus.svg" alt="">
              </div>
            </div>
            <div class="col-sm-1" v-if="hasMultiple && canEdit">
              <div class="minus" @click="toggleContact('remove')">
                <img src="../../assets/letter-x.svg" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- drop the thingy here -->
      <div class="card-section sub-section" v-if="canEdit">
        <div class="row section-body button">
          <div class="col-sm-3 section-property-block">
            <btn type="primary" @click="submitOrganization()">Update</btn>
              <btn type="danger" @click="deleteOrganization()">Delete</btn>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState, mapGetters } from 'vuex';
import $ from 'jquery';
import constants  from '../../constants.js';
import moment from 'moment';
import { bus } from '../../main';
import store from '../../store.js';
import Popups from '../Popups'
import Vue from 'vue';
import Selectize from 'vue2-selectize';
import _ from 'lodash';
import VueSelect from 'vue-select';
import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo);

export default{
    props: {
      editable: { type: Array, default: () => [] },
      detailBody:{ default: () => ({}) },
    },

    data: function(){
      return {
        errors: [],
        hasMultiple: false,
        hasExceeded: false,
        message: { type: 'warning', title: 'Organization' },
        confirm_contacts: [],
        status_options: ['active', 'inactive'],
        contact_fields: [['contact_method', 'value']],
        additional_contact_fields: [['contact_method', 'value']],
        contact_options: ['email', 'fax', 'telephone', 'website'],
      };
    },

    computed: {
      ...mapGetters([ 'hasErrors', 'getErrors' ]),
      ...mapState({
        selectedOrganization: function(state) {
          return state.selectedOrganization;
        },
        selectedOrganizationContacts: function(state) {
          let contacts = state.selectedOrganization.contacts;
          return (contacts !== undefined)? state.selectedOrganization.contacts : [];
        },
        canEdit: function(route){
          return store.getters.hasPerm('change_organization');
        },
      }),
    },

    methods: {
      toggleSidebar(){
        bus.$emit('toggle-sidebar');
      },

      redirect: function(action) {
        if (action === 'success' || action === 'delete') this.$router.push('/organizations');
      },

      reset: function() {
        this.errors = [];
        bus.$emit('reset', {});
      },

      removeContact: function (index) {
        if (this.selectedOrganizationContacts.length > 0) {
          this.$confirm({
            title: 'Confirm Action',
            content: 'Are you sure you want to remove this contact?',
          }).then(() => {
              this.selectedOrganizationContacts.splice(index, 1);
            }).catch(() => {
              this.$notify('Request has been cancelled.')
            });
        }
      },

      formatDateTime: function(data, format) {
        return (!data)? '--': moment(data).format(format);
      },

      toggleContact: function (action) {
        let total = this.selectedOrganizationContacts.length
        let count = total + this.additional_contact_fields.length;

        if (action == 'add') {
          if (count < 6) {
            this.additional_contact_fields.push(['contact_method', 'value']);
            count += 1;
          }
          if (count >= 6) this.hasExceeded = true;
        } else {
            if (count > 1) {
              this.additional_contact_fields.pop();
              count -= 1;
              if (this.hasExceeded) this.hasExceeded = false;
            }
          }

        this.hasMultiple = (this.additional_contact_fields.length > 1)? true : false;
      },

      showPopup: function(value, type) {
        bus.$emit(type, { data: value });
        this.redirect(value.type);
      },

      confirmAction: function(data, action) {
        this.$confirm({
            title: 'Confirm Action',
            content: constants.message[action].action,
          }).then(() => {
            this.actionOrganization(data, action)
            }).catch(() => {
              this.$notify('Request has been cancelled.')
            });
      },

      actionOrganization: async function(data, action) {
        let failed = constants.message[action].failed;
        let success = constants.message[action].success;
        let response = await store.dispatch(((action == 'update')? 'updateSelectedOrganization'
            : 'deleteSelectedOrganization'), { organization: data });

        if(response === 'success' || response != undefined){
        this.message.type = 'success';
        this.message.content = success;
      } else {
        this.message.type = 'warning';
        this.message.content = failed;
      }

        this.showPopup(this.message, 'notification');
      },

      submitOrganization: async function () {
        this.reset();
        let _errors=this.errors

        // form variable
        let data = {};
        let contacts = [];
        let re = /^(([a-zA-Z0-9]+)|([a-zA-Z0-9]+((?:\_[a-zA-Z0-9]+)|(?:\.[a-zA-Z0-9]+))*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-zA-Z]{2,6}(?:\.[a-zA-Z]{2})?)$)/;


        //form field names
        let name = $("#organization-name").val();
        let address = $("#organization-address").val();
        let state = $("#organization-status option:selected").val();

        if(name.length < 1) {
          this.errors.push('An organization name is required!');
        }
        if(address.length < 1) {
          this.errors.push('Please provide an address for this organization!');
        }

        // get organization updated contacts
        $('.contact').each(function(i, obj) {
          let _list = this.errors;
          let value = this.querySelector("input[type=text]").value;
          let category = $("#contact_method-" +i+" option:selected").val();

          if (category.length > 0 && value.length > 0 && category=="email"){
            if (re.test(value)==true){
              contacts.push({'category': category, 'value': value});
              console.log("good job");
            }
            else {
              _errors.push('Incorrect email format for contact information');
            }
          }
          else if (category.length > 0 && value.length > 0 && category!="email") {
            contacts.push({'category': category, 'value': value});
          }
        });

         this.errors.concat(_errors);
         console.log(this.errors)

        // get organization addtional contacts
        $('.additional').each(function(i, obj) {
          let value = this.querySelector("input[type=text]").value;
          let category = $("#add-contact_method-" +i+" option:selected").val();
          if (category.length > 0 && value.length > 0 && category=="email"){
            if (re.test(value)==true){
              contacts.push({'category': category, 'value': value});
              console.log("good job");
            }
            else {
              _errors.push('Incorrect email format for addition contact information');
            }
          }
          else if (category.length > 0 && value.length > 0 && category!="email") {
            contacts.push({'category': category, 'value': value});
          }
        });

        console.log("try again");

        data = { 'id': this.selectedOrganization.id, 'name': name,
                 'state': state, 'address': address, 'contacts': contacts };
        if (this.errors.length > 0) this.showPopup({'content': this.errors }, 'alert');
        else this.confirmAction(data, 'update');
      },

      deleteOrganization: function () {
        let selectedOrganization = this.selectedOrganization;
        this.confirmAction(selectedOrganization, 'delete');
      },

      scrolled: function(){
         VueScrollTo.scrollTo('#scroll', 500,{ easing: VueScrollTo.easing['ease']});
      }
    },

    components: {
      Selectize,
      VueSelect,
      Popups
    },

    beforeRouteEnter (to, from, next) {
      store.dispatch('fetchSelectedOrganization', { id: to.params.id });
      next();
    },

    beforeDestroy () {
      store.dispatch('resetErrors');
    },
};
</script>

<style scoped lang="scss">
@import "../../css/constants";
/* body select.select_box option */
body select option { padding: 0 4px; }
/* for IE and Edge */
select::-ms-expand { display: none; }
select:disabled::-ms-expand { background: #f60; }

h1.detail-title{
  background-color: #04bafc;
  padding: 20px;
  margin-left: -40px;
  margin-right: -40px;
  color: white;
  height: auto;
  margin-bottom: 25px;

  i {
    cursor: pointer;
    display: none;
    font-size: 1.1em;
    margin-top: -4px;
    vertical-align: middle;
    text-shadow:  0px 1px 1px rgba(0, 0, 0, 0.1);

    &:hover {
      color: #f1f1f1;
    }
  }
}

.tool-tip{
  display: none;
  color: grey;
  background-color: #ececec;
  border-radius: 4px;
  position:absolute;
  margin-top: -40px;
  width: fit-content;
  padding-top:5px;
  padding-bottom:5px;
  padding-left: 5px;
  padding-right:5px;
  z-index: 100;
}
.tool-tip::after{
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #ececec transparent transparent transparent;
}
.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.section-property:hover{
  display: block;
}
.container-fluid {
    padding: auto;
}
.card-section {
  display: flex;
  flex-direction: column;
}

.card-sub-body {
  margin-top: 20px !important;
  border-top: 1px solid #ddd;
  padding: 25px 0 0 0;
}

.section-body { display: flex; flex-wrap: wrap; }

.sub-section { margin-top: 30px; }
.more { margin-top: 50px; }
.section-title {
    font-family: 'Roboto Slab', serif;
    font-weight: bold;
    color: $gray7;
    font-size: 20px;
    line-height: $p20;
    margin-bottom: $p24;
}
.section-property-block {
  margin-right: $p16;
	margin-bottom: $p16;
	// min-width: 140px;
}
.section-property-title {
    position:relative;
    z-index:1;
    color: $gray5;
    text-transform: uppercase;
    margin-bottom: $p16;
    font-size: 14px;
    line-height: $p14;
}
.section-property-container {
  height: $p32;
}
.section-property {
    color: #7b7b7b;
    border:none;
    word-wrap: break-word;
    cursor: pointer;
    width: 100%;
    font-size: 14px;
}
.detail-card-body{
    background-color: white;

}
@media (min-width: 576px){
  .col-sm-2 {
    max-width: 15.666667%;
  }
}
//Reset Grid
.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4,
.col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10,
.col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6,
.col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12,
.col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8,
.col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3,
.col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9 {
  padding: 0;
}
//Reset row
.row {
  margin: 0;
}

.minus, .plus{
  border: 1px solid #cfcfcf;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  display: flex;
  margin-top: 5px;
  cursor: pointer;
  margin-top: 30px;
  margin-left: 10px;
}

.additional .minus { margin-left: 25px; }
.minus > img, .plus > img{ margin: auto; }

button.save {
  width: 100px;
  height: $p32;
  border: 1px solid $gray4;
  border-radius: 4px;
  background-color: white;
  font-size: $p14;
  color:grey;
  &:focus {
    outline: none;
  }
}

@media only screen and (min-width: 768px) {
  /* For mobile phones: */
  h1.detail-title {
    padding-left: 45px;
  }
}

@media only screen and (min-width: 468px) and (max-width: 768px) {
  /* For mobile phones: */
  h1.detail-title {
    padding-left: 45px;
    i { display: inline-block; margin-right: 15px;  }
  }
}

@media only screen and (max-width: 467px) {
  /* For mobile phones: */
  h1.detail-title {
    padding-left: 45px;
    i { display: inline-block; margin-right: 15px; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organization/OrganizationDetail.vue